module.exports = __webpack_public_path__ + "static/media/Kowanyama.5a81222d.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Kowanyama.bmp
// module id = 631
// module chunks = 0